import React, { createContext, useState, useContext } from "react";

const ViewContext = createContext();

export const useView = () => {
  return useContext(ViewContext);
};

export const ViewProvider = ({ children }) => {
  // null: auto-detect, true: force mobile, false: force desktop
  const [manualMobileViewOverride, setManualMobileViewOverride] =
    useState(null);

  const toggleManualMobileView = () => {
    setManualMobileViewOverride((prev) => {
      if (prev === null) return true; // Auto -> Force Mobile
      if (prev === true) return false; // Force Mobile -> Force Desktop
      if (prev === false) return null; // Force Desktop -> Auto
      return null; // Default fallback
    });
  };

  const value = {
    manualMobileViewOverride,
    toggleManualMobileView,
  };

  return <ViewContext.Provider value={value}>{children}</ViewContext.Provider>;
};
